import { render, staticRenderFns } from "./CandidateAssessment.vue?vue&type=template&id=576ba3d5&scoped=true&"
import script from "./CandidateAssessment.vue?vue&type=script&lang=ts&"
export * from "./CandidateAssessment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ba3d5",
  null
  
)

export default component.exports